import { render } from "./document-templates.vue?vue&type=template&id=6b922b20"
import script from "./document-templates.vue?vue&type=script&lang=js"
export * from "./document-templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__